var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_563_445)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 9.75,
    width: 22.5,
    height: 41.5,
    rx: 6.25,
    stroke: "#F5F5F6",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 17.6001C13.2501 18.6356 14.0896 19.4751 15.1251 19.4751C16.1607 19.4751 17.0001 18.6356 17.0001 17.6001C17.0001 16.5646 16.1607 15.7251 15.1251 15.7251C14.0896 15.7251 13.2501 16.5646 13.2501 17.6001Z",
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2003 25.7249C13.1953 25.347 13.3032 24.9763 13.51 24.66C13.7169 24.3437 14.0134 24.0964 14.3616 23.9495C14.7097 23.8026 15.0938 23.7628 15.4647 23.8354C15.8356 23.9079 16.1764 24.0893 16.4436 24.3565C16.7108 24.6238 16.8923 24.9646 16.9648 25.3355C17.0373 25.7063 16.9976 26.0904 16.8507 26.4386C16.7038 26.7868 16.4564 27.0833 16.1402 27.2901C15.8239 27.497 15.4531 27.6048 15.0753 27.5999C14.58 27.5934 14.1068 27.3938 13.7566 27.0436C13.4064 26.6933 13.2067 26.2202 13.2003 25.7249Z",
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 45.1001L13.2501 35.1001C13.2501 34.6028 13.4477 34.1259 13.7993 33.7743C14.1509 33.4226 14.6278 33.2251 15.1251 33.2251C15.6224 33.2251 16.0993 33.4226 16.4509 33.7743C16.8026 34.1259 17.0001 34.6028 17.0001 35.1001L17.0001 45.1001C17.0001 45.5974 16.8026 46.0743 16.4509 46.4259C16.0993 46.7776 15.6224 46.9751 15.1251 46.9751C14.6278 46.9751 14.1509 46.7776 13.7993 46.4259C13.4477 46.0743 13.2501 45.5974 13.2501 45.1001Z",
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.75,
    y: 9.75,
    width: 22.5,
    height: 41.5,
    rx: 6.25,
    stroke: "#F5F5F6",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.25 17.6001C43.25 18.6356 44.0895 19.4751 45.125 19.4751C46.1605 19.4751 47 18.6356 47 17.6001C47 16.5646 46.1605 15.7251 45.125 15.7251C44.0895 15.7251 43.25 16.5646 43.25 17.6001Z",
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2002 25.7249C43.1952 25.347 43.3031 24.9763 43.5099 24.66C43.7168 24.3437 44.0133 24.0964 44.3614 23.9495C44.7096 23.8026 45.0937 23.7628 45.4646 23.8354C45.8355 23.9079 46.1763 24.0893 46.4435 24.3565C46.7107 24.6238 46.8922 24.9646 46.9647 25.3355C47.0372 25.7063 46.9975 26.0904 46.8506 26.4386C46.7037 26.7868 46.4563 27.0833 46.14 27.2901C45.8238 27.497 45.453 27.6048 45.0752 27.5999C44.5799 27.5934 44.1067 27.3938 43.7565 27.0436C43.4063 26.6933 43.2066 26.2202 43.2002 25.7249Z",
    fill: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.25 45.1001L43.25 35.1001C43.25 34.6028 43.4475 34.1259 43.7992 33.7743C44.1508 33.4226 44.6277 33.2251 45.125 33.2251C45.6223 33.2251 46.0992 33.4226 46.4508 33.7743C46.8025 34.1259 47 34.6028 47 35.1001L47 45.1001C47 45.5974 46.8025 46.0743 46.4508 46.4259C46.0992 46.7776 45.6223 46.9751 45.125 46.9751C44.6277 46.9751 44.1508 46.7776 43.7992 46.4259C43.4475 46.0743 43.25 45.5974 43.25 45.1001Z",
    fill: "#F5F5F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_563_445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(60) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/Icon4.30fcdd2f.svg";
export { ForwardRef as ReactComponent };